import { useFetchInfinite } from 'shared/hooks'

export type SelectOption = { label: string; value: number }

type OptionsSource = {
	name: string
	endpoint: string
	enabled: boolean
	query?: string
	getLabel?: (item: any) => string
}

export const useOptions = <T = any>({
	name,
	endpoint,
	enabled,
	query,
	getLabel = (item) => item.name
}: OptionsSource) => {
	const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } = useFetchInfinite<T>({
		name,
		endpoint,
		query,
		enabled
	})

	const items: T[] = (data?.pages ?? []).flatMap((page) => page.results ?? [])
	const options: SelectOption[] = items.map((item: any) => ({
		label: getLabel(item),
		value: item.id
	}))

	return {
		items,
		options,
		isLoading: enabled && isLoading,
		fetchNextPage,
		hasNextPage,
		isFetchingNextPage
	}
}
